import Logo from "../assets/images/logo.webp";
import Banner from "../assets/images/banner.png";
import Second from "../assets/images/second.webp";
import CardOne from "../assets/images/card1.webp";
import CardTwo from "../assets/images/card2.webp";
import CardThree from "../assets/images/card3.webp";
import Background from "../assets/images/background.png";
import Bolsa from "../assets/images/BOLSA.webp";
import TONINHO from "../assets/images/TONINHO.webp";
import Coffee from "../assets/images/coffee.webp";
import SmosOne from "../assets/images/smos-1.webp";
import SmosTwo from "../assets/images/smos-2.webp";
import Americano from "../assets/images/americano.webp";
import Javaccino from "../assets/images/javaccino.webp";
import Bagel from "../assets/images/bagel.webp";
import Amapola from "../assets/images/amapola.webp";
import Intergel from "../assets/images/intergel.webp";
import Semillas from "../assets/images/semillas.webp";
import Fermantada from "../assets/images/fermentada.webp";
import Masa from "../assets/images/masa.webp";
import MasaIntegral from "../assets/images/masa-integral.webp";
import Jala from "../assets/images/jala.webp";
import Druppar from "../assets/images/drupper.webp";
import JavaTimes from "../assets/images/javatimes.png";
import BranchFooter from "../assets/images/branch-footer.webp";
import Cafeteria from "../assets/images/cafeteria.webp";
import Copia from "../assets/images/copia.webp";
import InvestmentBg from "../assets/images/investment-bg.webp";
import RaceImage from "../assets/images/race.webp";
import Unkown from "../assets/images/unkown.jpg";
import BlogOne from "../assets/images/blog-1.webp";
import InvestNowImg from "../assets/images/invest-now-img.webp";
import LocationImg from "../assets/images/location-icon.webp";
import whiteLogo from "../assets/images/logo-white.png";
import userIcon from "../assets/images/user-icon.png";
import userSearchIcon from "../assets/images/user-search-icon.png";
import walletIcon from "../assets/images/wallet-icon.png";
import Amount from "../assets/images/amount.png";
import Shares from "../assets/images/shares.png";
import Profit from "../assets/images/profit.png";
// import SharesLeft from "../assets/images/sharesleft.png";
import WalletCardIcon from "../assets/images/card-wallet-icon.png";
import Logout from "../assets/images/logout.png";
import CoffeCup from "../assets/images/coffee-cup.webp";
import CoffeCupDouble from "../assets/images/coffee-cup-double.webp";
import ShareTable1 from "../assets/images/share-table-1.webp";
import ShareTable2 from "../assets/images/share-table-2.webp";
import ShareTable3 from "../assets/images/share-table-3.webp";
import ShareTable4 from "../assets/images/share-table-4.webp";
import ShareTableBg2 from "../assets/images/share-table-background-2.webp";
import DocumentationBg from "../assets/images/documentation-process-bg.webp";
import NotFoundImg from "../assets/images/404.jpg";

export {
  Logout,
  Logo,
  WalletCardIcon,
  Banner,
  Second,
  CardOne,
  CardTwo,
  CardThree,
  Background,
  Bolsa,
  TONINHO,
  Coffee,
  SmosOne,
  SmosTwo,
  Americano,
  Javaccino,
  Bagel,
  Amapola,
  Intergel,
  Semillas,
  Fermantada,
  Masa,
  MasaIntegral,
  Jala,
  Druppar,
  JavaTimes,
  BranchFooter,
  Cafeteria,
  Copia,
  NotFoundImg,
  InvestmentBg,
  RaceImage,
  Unkown,
  BlogOne,
  InvestNowImg,
  LocationImg,
  whiteLogo,
  userIcon,
  userSearchIcon,
  walletIcon,
  Amount,
  Shares,
  Profit,
  CoffeCup,
  CoffeCupDouble,
  ShareTable1,
  ShareTable2,
  ShareTable3,
  ShareTable4,
  ShareTableBg2,
  DocumentationBg,
};
